import { AudiencePreset } from 'app/modules/posts/api/audienceRestrictions';
import { AudienceRestrictions } from 'app/modules/posts/types/AudienceRestrictionsOptions';
import {
  TYPE_FACEBOOK,
  TYPE_LINKEDIN,
} from '@kontentino/kontentino-constants/Pages';
import { AUDIENCE_RESTRINCTION_EMPTY_VALUE } from '../constants/audienceRestrictions';

function transformFacebookPreset(preset: AudiencePreset): AudienceRestrictions {
  const audienceRestrictionsData = preset.audience_restrictions;

  if (!audienceRestrictionsData) {
    return {};
  }

  const keys = Object.keys(audienceRestrictionsData);
  if (keys.length === 0) {
    return {};
  }

  const firstKeyData = audienceRestrictionsData[keys[0]];

  if (!firstKeyData) {
    return {};
  }

  return {
    ...firstKeyData,
    age_min: firstKeyData.age ?? AUDIENCE_RESTRINCTION_EMPTY_VALUE.value,
  };
}

function transformLinkedInPreset(preset: AudiencePreset): AudienceRestrictions {
  const audienceRestrictionsData = preset.audience_restrictions;

  if (!audienceRestrictionsData) {
    return {};
  }

  return audienceRestrictionsData;
}

export function transformPresetForPageType(
  preset: AudiencePreset,
  pageType: number,
): AudienceRestrictions {
  switch (pageType) {
    case TYPE_FACEBOOK:
      return transformFacebookPreset(preset);
    case TYPE_LINKEDIN:
      return transformLinkedInPreset(preset);
    default:
      return {};
  }
}
